import { render, staticRenderFns } from "./etcLongDistance.vue?vue&type=template&id=9ace5780&scoped=true"
import script from "./etcLongDistance.vue?vue&type=script&lang=js"
export * from "./etcLongDistance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ace5780",
  null
  
)

export default component.exports